import React, { useState, useEffect, useRef  } from 'react'
import './new.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import {serverTimestamp, collection, addDoc} from "firebase/firestore";
import { db, storage } from "../../../firebase";
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom"
import { TextField, Button } from '@mui/material';

import Box from '@mui/material/Box';


const New = () => {

  const [isloading, setIsloading ] = useState(false)

  const today = new Date().toDateString()

  const [premiumServiceCharge, setPremiumServiceCharge] = useState("")

  const [regularServiceCharge, setRegularServiceCharge] = useState("")

  const [visaFee, setVisaFee] = useState("")

  const [errorPremiumServiceCharge, setErrorPremiumCharge] = useState(false)

  const [errorRegularServiceCharge, setErrorRegularServiceCharge] = useState(false)

  const [errorVisaFee, setErrorVisaFee] = useState(false)

  const navigate = useNavigate();


    
    const handleNairaCharges = async(e) => {
  
      e.preventDefault()

      if(premiumServiceCharge === ""){
        
        return setErrorPremiumCharge("This field is required")
      }

       if(regularServiceCharge === ""){
        
        return setErrorRegularServiceCharge("This field is required")
      }

      if(visaFee === ""){
        
        return setErrorVisaFee("This field is required")
      }


      setIsloading(true)
  
      try{
           
         const advertResponse = await addDoc(collection(db, "nairaCharges"), {
        
          premiumServiceCharge: Number(premiumServiceCharge),
          regularServiceCharge: Number(regularServiceCharge),
          visaFee: Number(visaFee),
          createdAt : today,
          
        });

        setIsloading(false)

        navigate("/nairaCharges")
        
      }catch (err) {

        console.log(err);

      } 
  
    }

    const handlePremiumService = (e) => {

          const { value } = e.target;

          const onlyNums = value.replace(/[^0-9]/g, ''); 

         setPremiumServiceCharge(onlyNums)

         if(premiumServiceCharge !== ""){

          setErrorPremiumCharge(false)
          
         }

    }

    
    const handleRegularService = (e) => {

         
          const { value } = e.target;

          const onlyNums = value.replace(/[^0-9]/g, ''); 

         setRegularServiceCharge(onlyNums )

         if(regularServiceCharge !== ""){

          setErrorRegularServiceCharge(false)
          
         }

    }


    const handleVisaFee = (e) => {

         
          const { value } = e.target; 
          
          const onlyNums = value.replace(/[^0-9]/g, ''); 

         setVisaFee(onlyNums )

         if(visaFee !== ""){

          setErrorVisaFee(false)
          
         }    

      }



  return (
    <div className="new">
      {/* {isloading && <Spinner />} */}
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>New Naira Charges</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/nairaCharges"
            >
              Naira Charge List
            </Link>
            <Typography color="green">New Naira Charge</Typography>
          </Breadcrumbs>
          </div>
        </div>
        <div className='bottom'>
       
        <div className='right'>
          <div className='form'>

                <div style={{display: 'flex', flexDirection:'row', width: '100%', gap:20, flexWrap:'wrap'}}>

                    <div style={{width:'32%', flexDirection:'column'}}>

                      <TextField
                          name="premiumServiceCharge"
                          placeholder="EnterPremium Service Charge eg 250,000"
                          value={premiumServiceCharge}
                          onChange={handlePremiumService}
                          style={{width:'100%', backgroundColor:'#bdcdf6'}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        {
                          errorPremiumServiceCharge &&

                          <p style={{color:'red', fontSize:15, }}>{errorPremiumServiceCharge}</p>

                        }

                    </div>

                    <div style={{width:'32%', flexDirection:'column'}}>

                      <TextField
                          name="regularServiceCharge"
                          placeholder="Enter Regular Service Charge eg 560,000"
                          value={regularServiceCharge}
                          onChange={handleRegularService}
                          style={{width:'100%', backgroundColor:'#bdcdf6'}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        {
                          errorRegularServiceCharge &&

                          <p style={{color:'red', fontSize:15, }}>{errorRegularServiceCharge}</p>

                        }

                    </div>


                     <div style={{width:'32%', flexDirection:'column'}}>

                      <TextField
                          name="visaFee"
                          placeholder="Enter Visa Fee eg 300, 000"
                          value={visaFee}
                          onChange={handleVisaFee}
                          style={{width:'100%', backgroundColor:'#bdcdf6'}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        {
                          errorVisaFee &&

                          <p style={{color:'red', fontSize:15, }}>{errorVisaFee}</p>

                        }

                      </div>


                
                </div>

                <hr style={{width:'100%', height:0, color:'$eee'}}/>

                  <Button 
                  
                    onClick={handleNairaCharges} 
                    disabled={isloading}
                    style={{width:'100%',height:60,  backgroundColor:'rgb(15, 31, 175)'}}>
                    {isloading ? '...loading Dollar Charges' : 'Save Dollar Charges'}
                    
                  </Button>

          </div>
        </div>
        </div>
      </div>
    </div>
  )
}

export default New














// import React, { useState } from 'react'
// import './new.scss'
// import Sidebar from '../../../components/sidebar/Sidebar'
// import Navbar from '../../../components/navbar/Navbar'
// import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
// import { db, storage } from "../../../firebase";
// import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
// import { useEffect } from 'react';
// import Typography from '@mui/material/Typography';
// import Breadcrumbs from '@mui/material/Breadcrumbs';
// import Link from '@mui/material/Link';
// import { collection, addDoc, serverTimestamp, doc, getDoc, updateDoc } from "firebase/firestore";
// import { useNavigate, useParams } from "react-router-dom"



// const New = ({inputs, title}) => {

//   const {chargeId} = useParams()

//   console.log("charge Id: ", chargeId)

//   const [ data, setData ] = useState({})
//   const [ isloading, setIsloading ] = useState(false)
//   const [charges, setCharges] = useState()
//   const [companyIntroduction, setCompanyIntroduction] = useState()
//   const [selfIntroduction, setSelfIntroduction] = useState()
//   const [leaveApproval, setLeaveApproval] = useState()
//   const [employmentLetter, setEmploymentLetter] = useState()
//   const [visaProcessingFee, setVisaProcessingFee] = useState() 

  
//   const navigate = useNavigate();


//   const Spinner = () => {
//     return(
//       <span className='spinner-container'>
//           <span className='loading-spinner'></span>
//       </span>
//     )
//   }

  

//   // useEffect(() => {

//   //   const uploadFile = () => {

//   //     const name = new Date().getTime() + file.name;
      
//   //     const storageRef = ref(storage, name);

//   //     const uploadTask = uploadBytesResumable(storageRef, file);

//   //     uploadTask.on('state_changed', 
//   //       (snapshot) => {
        
//   //         const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//   //         console.log('Upload is ' + progress + '% done');
//   //         setPerc(progress)
//   //         switch (snapshot.state) {
//   //           case 'paused':
//   //             console.log('Upload is paused');
//   //             break;
//   //           case 'running':
//   //             console.log('Upload is running');
//   //             break;
//   //           default:
//   //             break;
//   //         }
//   //       }, 
//   //       (error) => {
//   //         console.log(error)
//   //       }, 
//   //       () => {
         
//   //         getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
//   //           setData((prev) => ({...prev, img: downloadURL}))
//   //         });
//   //       }
//   //     );

//   //   };

//   //   file && uploadFile();

//   // }, [file]);

//   // const handleInput = (event) =>{
   
//   //   setData(event.target.value)
//   // }


//   const handleUpdate = async(e) => {

//       e.preventDefault()
//       setIsloading(true)
//     try {
      
//       await updateDoc(doc(db, "charges", chargeId), {


//           companyIntroduction : Number(companyIntroduction),
//           selfIntroduction : Number(selfIntroduction),
//           leaveApproval : Number(leaveApproval),
//           employmentLetter : Number(employmentLetter),
//           visaProcessingFee : Number(visaProcessingFee),
//     });

                  
//                 setIsloading(false)

//                 navigate('/charges')

            
//           } catch (error) {

//             console.log('error:',error.message)

//           }

//           }

  
//   // const handleAdd = async(e) => {

//   //   e.preventDefault()
//   //   setIsloading(true)

//   //   try{
       
       
//   //      await addDoc(collection(db, "charges"), {
//   //       ...data, charges : 'visaCharges',
//   //       timeStamp: serverTimestamp(),
        

//   //     });
      
//   //     setIsloading(false)

//   //     navigate('/charges')
      
      
//   //   }catch (err) {
//   //     console.log(err);
//   //   } 

//   // }

//   const getCharge = async() => {

//     const docRef = doc(db, "charges", chargeId);

//     const docSnap = await getDoc(docRef);

        
//     if (docSnap.exists()) {

//       setCharges(docSnap.data() )

//     } else {
      
//       console.log("No such document!");
//     }


// }

// console.log('charges: ',charges)



 

// useEffect(()=>{

//   getCharge()

// }, [])



//   console.log("charge Id: ", chargeId)

//   return (
//     <div className="new">
//       <Sidebar/>
//       <div className="newContainer">
//       <Navbar/>
//         <div className='top'>
//         <div className='topLeft'><h1>{title}</h1></div>
          
//           <div className='topRight'>
//           <Breadcrumbs aria-label="breadcrumb">
//             <Link underline="hover" color="inherit" href="/">
//               Home
//             </Link>
//             <Link
//               underline="hover"
//               color="inherit"
//               href="/charges"
//             >
//               Charges List
//             </Link>
//             <Typography color="green">Add Charges</Typography>
//           </Breadcrumbs>
//           </div>
//         </div>
        
//         <div className='bottom'>
//           {/* <div className="left">

//               <img
//                 src={file 
//                   ? URL.createObjectURL(file) 
//                   : "../images/hamburger.png"}
//                 alt=""
//                 className='imgs'
//                 resizeMode = "contain"
//               />
              
//           </div> */}
//           <div className='right'>
//           <form onSubmit={handleUpdate}>

//               <div className='formInput' >
//                   <label>Company Introduction:</label>
//                   <input type="text" placeholder="$15" value={companyIntroduction} onChange={e => setCompanyIntroduction(e.target.value)} id="companyIntroduction" required/>
//               </div>
              

//               <div className='formInput' >
//                   <label>Self Introduction:</label>
//                   <input type="text" placeholder="$15" value={selfIntroduction}  onChange={e => setSelfIntroduction(e.target.value)} id="selfIntroduction" required/>
//               </div>

//               <div className='formInput' >
//                   <label>Leave Approval:</label>
//                   <input type="text" placeholder="$15" value={leaveApproval}  onChange={e => setLeaveApproval(e.target.value)} id="leaveApproval" required/>
//               </div>

//               <div className='formInput' >
//                   <label>Employment Letter:</label>
//                   <input type="text" placeholder="$15" value={employmentLetter}  onChange={e => setEmploymentLetter(e.target.value)} id="employmentLetter" required/>
//               </div>

//               <div className='formInput' >
//                   <label>Visa Processing Fee:</label>
//                   <input type="text" placeholder="$15" value={visaProcessingFee}  onChange={e => setVisaProcessingFee(e.target.value)}id="visaProcessingFee" required/>
//               </div>

//               <button type='Update'>
//               {isloading && <span>...</span>}
//               {isloading ? <span>loading</span> : <span>Submit</span>}


//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default New






